import { call, put } from "redux-saga/effects";

import {
  FETCH_EPISODE_DAY_REQUEST,
  FETCH_EPISODE_LISTENERS_REQUEST,
  FETCH_FEED_DAY_REQUEST,
  FETCH_FEED_LISTENERS_REQUEST,
  FETCH_SNAPSHOT_REQUEST,
  fetchEpisodeDayFailure,
  fetchEpisodeDaySuccess,
  fetchEpisodeListenersFailure,
  fetchEpisodeListenersSuccess,
  fetchFeedDayFailure,
  fetchFeedDaySuccess,
  fetchFeedListenersFailure,
  fetchFeedListenersSuccess,
  fetchSnapshotFailure,
  fetchSnapshotSuccess,
} from "../stats";
import {
  getFeedDay,
  getFeedEpisodeDay,
  getFeedEpisodeListeners,
  getFeedListeners,
  getFeedSnapshot,
} from "../../lib/api/queries/analyticsQueries";

const getErrorMessage = (error) => error?.message || "Request failed";

export function* fetchFeedDayWorker({ payload }) {
  try {
    const response = yield call(getFeedDay, payload);
    yield put(fetchFeedDaySuccess(response.data));
  } catch (error) {
    yield put(fetchFeedDayFailure(getErrorMessage(error)));
  }
}

export function* fetchEpisodeDayWorker({ payload }) {
  try {
    const response = yield call(getFeedEpisodeDay, payload);
    yield put(fetchEpisodeDaySuccess(response.data));
  } catch (error) {
    yield put(fetchEpisodeDayFailure(getErrorMessage(error)));
  }
}

export function* fetchFeedListenersWorker({ payload }) {
  try {
    const response = yield call(getFeedListeners, payload);
    yield put(
      fetchFeedListenersSuccess({
        ...response.data,
        ...response.pagination,
      }),
    );
  } catch (error) {
    yield put(fetchFeedListenersFailure(getErrorMessage(error)));
  }
}

export function* fetchEpisodeListenersWorker({ payload }) {
  try {
    const response = yield call(getFeedEpisodeListeners, payload);
    yield put(
      fetchEpisodeListenersSuccess({
        ...response.data,
        ...response.pagination,
      }),
    );
  } catch (error) {
    yield put(fetchEpisodeListenersFailure(getErrorMessage(error)));
  }
}

export function* fetchSnapshotWorker({ payload }) {
  try {
    const response = yield call(getFeedSnapshot, payload);
    yield put(fetchSnapshotSuccess(response.data));
  } catch (error) {
    yield put(fetchSnapshotFailure(getErrorMessage(error)));
  }
}

export const statsWatchers = [
  [FETCH_FEED_DAY_REQUEST, fetchFeedDayWorker],
  [FETCH_EPISODE_DAY_REQUEST, fetchEpisodeDayWorker],
  [FETCH_FEED_LISTENERS_REQUEST, fetchFeedListenersWorker],
  [FETCH_EPISODE_LISTENERS_REQUEST, fetchEpisodeListenersWorker],
  [FETCH_SNAPSHOT_REQUEST, fetchSnapshotWorker],
];
